export const Calendar = {
	calendarBackground: 'var(--epods--calendar-background)',
	calendarForeground: 'var(--epods--calendar-foreground)',
	calendarForegroundDisabled: 'var(--epods--calendar-foreground-disabled)',
	calendarHeaderBackground: 'var(--epods--color-bg-heading)',
	calendarHeaderForeground: 'var(--epods--calendar-header-foreground)',
	calendarHeaderBackgroundActive: 'var(--epods--calendar-header-background-active)',
	calendarHeaderForegroundDisabled: 'var(--epods--calendar-header-foreground-disabled)',
	calendarDayBackgroundPseudoSelected: 'var(--epods--calendar-day-background-pseudo-selected)',
	calendarDayForegroundPseudoSelected: 'var(--epods--calendar-day-foreground-pseudo-selected)',
	calendarDayBackgroundPseudoSelectedHighlighted: 'var(--epods--calendar-day-background-pseudo-selected-highlighted)',
	calendarDayForegroundPseudoSelectedHighlighted: 'var(--epods--calendar-day-foreground-pseudo-selected-highlighted)',
	calendarDayBackgroundSelected: 'var(--epods--calendar-day-background-selected)',
	calendarDayForegroundSelected: 'var(--epods--calendar-day-foreground-selected)',
	calendarDayBackgroundSelectedHighlighted: 'var(--epods--calendar-day-background-selected-highlighted)',
	calendarDayForegroundSelectedHighlighted: 'var(--epods--calendar-day-foreground-selected-highlighted)',
};

export const CustomCalendar = {
	dayWidth: 'var(--epods--calendar-day-width)',
	dayHeight: 'var(--epods--calendar-day-height)',

	marginTop: 'var(--epods--calendar-day-margin-top)',
	marginBottom: 'var(--epods--calendar-day-margin-bottom)',

	containerPaddingTop: 'var(--epods--calendar-container-padding-top)',
	containerPaddingBottom: 'var(--epods--calendar-container-padding-bottom)',
	containerPaddingHorizontal: 'var(--epods--calendar-container-padding-horizontal)',

	weekPaddingBottom: 'var(--epods--calendar-week-padding-bottom)',

	calendarHeaderBackground: 'var(--epods--calendar-header-background)',
};
